export default __webpack_public_path__ + "static/media/7e081516917844ecec3cae1620c7f32a.svg";